import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedPatrimoineAncetreApiService } from './patrimoine-ancetre-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class PatrimoineAncetreApiService extends GeneratedPatrimoineAncetreApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
